export enum ContentHeadersEnum {
	TYPE = 'content-type',
	DISPOSITION = 'content-disposition'
}
